/**
 * Enum representing different time window options.
 */

export enum TimeUnit {
  Undefined = 'Undefined',
  Millisecond = 'Millisecond',
  Second = 'Second',
  Minute = 'Minute',
  Hour = 'Hour',
  Day = 'Day',
  Month = 'Month',
  Year = 'Year',
}
